export default __webpack_public_path__ + "static/media/format_study1.bac538cc.svg";